import { getOrdersCount } from "action/utils/getOrdersCount";
import { removeSavedItemApi } from "api/shopping-cart/removeSavedItemApi";
import { hideLoader } from "../loader/hideLoader";
import { showLoader } from "../loader/showLoader";
import { refreshShoppingCart } from "./refreshShoppingCart";

/*
 * saved list actions
 */

export function removeSavedItem(sku: any, callback = null) {
  return (dispatch: any) => {
    dispatch(showLoader());
    removeSavedItemApi(sku).then(() => {
      dispatch(hideLoader());
      dispatch(getOrdersCount());
      dispatch(refreshShoppingCart(callback));
    });
  };
}
